import $ from 'jquery';
import 'select2';
import axios from 'axios';
import { Chart } from 'chart.js';

export default function dashboard() {
    let data;
    let activitiesData;
    let chartAmountOfPersonsInstance;
    let chartAmountOfVisitsInstance;
    let chartAmountOfBookingsInstance;
    let chartCountryOfOriginInstance;

    const form = document.getElementById('form');
    const error = document.getElementById('error');
    const loader = document.getElementById('loader');
    const maisons = document.getElementById('filter_maison');
    const statuses = document.getElementById('filter_statuses');
    const activities = document.getElementById('filter_activities');
    const statistics = document.getElementById('statistics');
    const chartAmountOfPersons = document.getElementById('chartAmountOfPersons');
    const chartAmountOfBookings = document.getElementById('chartAmountOfBookings');
    const chartCountryOfOrigin = document.getElementById('chartCountryOfOrigin');

    const select2config = {
        width: '100%',
    };

    $(maisons).select2(select2config);
    $(statuses).select2(select2config);
    $(activities).select2(select2config);

    const getData = async () => {
        error.classList.remove('is-visible');
        loader.classList.add('is-loading');

        try {
            const response = await axios.post('/admin/api/statistics', new FormData(form));

            data = response.data;
            activitiesData = response.data?.activities || [];

            loader.classList.remove('is-loading');
        } catch (err) {
            error.classList.add('is-visible');
            loader.classList.remove('is-loading');
        }
    };

    const getActivities = async () => {
        try {
            const response = await axios.post('/admin/api/activities', new FormData(form));

            activitiesData = response.data;

            createActivities();
        } catch (err) {
            //
        }
    }

    const createStats = () => {
        if (!data) return;

        const cards = Object.values(data).filter((statistic) => statistic.type === 'card');

        statistics.innerHTML = cards?.length
            ? cards.map((card) => (`
                <div class="col-md-4 col-lg-3">
                    <div class="statistic-card">
                        <div class="statistic-card__title">
                            ${card.title}
                        </div>

                        <div class="statistic-card__value">
                            ${card.value}
                        </div>
                    </div>
                </div>
              `)).join('')
            : '';
    }

    const createCharts = async () => {
        if (!data) return;

        const countryOfOrigin = {
            ...data.country_of_origin,
            options: {
                tooltips: {
                    callbacks: {
                        title: () => '',
                        label: function(tooltipItem, data) {
                            const dataLabel = data.labels[tooltipItem.index];
                            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                            return dataLabel.replace(' (' + value + ')', '') + ': ' + value;
                        },
                    },
                }
            },
        };

        chartAmountOfPersonsInstance = new Chart(chartAmountOfPersons, data.amount_of_persons);
        chartAmountOfVisitsInstance = new Chart(chartAmountOfVisits, data.amount_of_visits);
        chartAmountOfBookingsInstance = new Chart(chartAmountOfBookings, data.amount_of_bookings);
        chartCountryOfOriginInstance = new Chart(chartCountryOfOrigin, countryOfOrigin);
    }

    const updateCharts = async () => {
        if (!data) return;

        chartAmountOfPersonsInstance.data = data.amount_of_persons.data;
        chartAmountOfVisitsInstance.data = data.amount_of_visits.data;
        chartAmountOfBookingsInstance.data = data.amount_of_bookings.data;
        chartCountryOfOriginInstance.data = data.country_of_origin.data;

        chartAmountOfPersonsInstance.update();
        chartAmountOfVisitsInstance.update();
        chartAmountOfBookingsInstance.update();
        chartCountryOfOriginInstance.update();
    }

    const createMaisons = async () => {
        if (!data) return;

        const optionAll = document.createElement('option');

        optionAll.text = 'Alle';
        optionAll.value = '';
        optionAll.selected = true;

        maisons.appendChild(optionAll);

        data.maisons.forEach((maison) => {
            const option = document.createElement('option');

            option.text = maison.name;
            option.value = maison.id;

            maisons.appendChild(option);
        });
    }

    const createStatuses = async () => {
        if (!data) return;

        data.statuses.forEach((status) => {
            const option = document.createElement('option');

            option.text = status.name;
            option.value = status.id;

            statuses.appendChild(option);
        });
    }

    const createActivities = async () => {
        if (!activitiesData) return;

        activities.innerHTML = '';

        activitiesData
            .sort((a, b) => a.name.localeCompare(b.name))
            .forEach((activity) => {
                const option = document.createElement('option');

                option.text = activity.name;
                option.value = activity.id;

                activities.appendChild(option);
            });
    }

    const createFormEventListeners = () => {
        $(maisons).on('change', getActivities);

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            filter();
        });
    }

    const filter = async () => {
        await getData();
        await createStats();
        await updateCharts();
    }

    const init = async () => {
        createFormEventListeners();

        await getData();
        await createStats();
        await createCharts();
        await createMaisons();
        await createStatuses();
        await createActivities();
    };

    init();
}
